import { render, staticRenderFns } from "./SadSmileySVG.vue?vue&type=template&id=7b0a4da4&scoped=true&"
import script from "./SadSmileySVG.vue?vue&type=script&lang=js&"
export * from "./SadSmileySVG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b0a4da4",
  null
  
)

export default component.exports